import React from 'react';
import { FormContext } from '../../../../components/molecules/Form';
import { InteractionStatus } from '../../../../types/InteractionStatus';
import LiveRegion from '../../../../components/atoms/LiveRegion/LiveRegion';
import Utils from '../../../../components/molecules/Form/Utils';
import { FileUploadResponseErrors } from '../../../FileUpload';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ButtonAction, ButtonActionConfirm } from '../../../../components/molecules/Btn/ButtonWrapper';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { AttachedFilesBaseFileLinkForm } from './AttachedFilesBaseFileLinkForm';
import { ComboBoxParam, SonForm } from '../../../Form2';
import { useDelayed } from '../../../../hooks/useDelayed';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

export enum AttachedFilesBaseUploadFormSendTemplateModifier {
  RIGHT = 'right',
}

type AttachedFilesBaseUploadFormSendTemplate = {
  submitButtonLabel: string;
  fileLink?: SonForm<ComboBoxParam<'fileResourceReference'>>;
  buttonWrapperModifier?: Modifier<AttachedFilesBaseUploadFormSendTemplateModifier>;
};

export function AttachedFilesBaseUploadFormSendTemplate({
  submitButtonLabel,
  fileLink,
  buttonWrapperModifier,
}: AttachedFilesBaseUploadFormSendTemplate) {
  const { t } = useSonTranslation('AttachedFiles');

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const delayedCloseModal = useDelayed(closeModal);

  return (
    <>
      <FormContext.Consumer>
        {({ submitActionEnabled, getStatus, status, response }) => (
          <>
            <div className="attached-files-base__button-container">
              <div className={bem('attached-files-base__button-wrapper', buttonWrapperModifier)}>
                {fileLink ? (
                  <div className="attached-files-base__button">
                    <ButtonAction
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                      text={t('fileLink.button')}
                      type="button"
                    />
                  </div>
                ) : null}
                <div className="attached-files-base__button">
                  <ButtonActionConfirm
                    text={submitButtonLabel}
                    ariaDisabled={!submitActionEnabled()}
                    type={submitActionEnabled() ? 'submit' : 'button'}
                  />
                </div>
              </div>
            </div>
            <LiveRegion invisible={false} htmlTag="div">
              {getStatus({
                [InteractionStatus.SUCCESS]: Utils.createStatusMessage(t('form.uploadSuccess')),
                maxUploadSizeExceeded: Utils.createStatusMessage(t('form.maxUploadSizeExceeded')),
              })}
              <FileUploadResponseErrors status={status} response={response} />
            </LiveRegion>
          </>
        )}
      </FormContext.Consumer>
      {fileLink && isModalOpen && (
        <ModalDialog closeModal={closeModal} headline={t('fileLink.headline')} initialFocusIndex={2}>
          <AttachedFilesBaseFileLinkForm form={fileLink} refresh={delayedCloseModal} />
        </ModalDialog>
      )}
    </>
  );
}
